import { Flex } from '@chakra-ui/react';
import { ReactComponent as Eye } from '../../assets/svgs/eye.svg';
import { ReactComponent as EditIcon } from '../../assets/svgs/edit.svg';
import { ReactComponent as DeleteIcon } from '../../assets/svgs/delete.svg';
import HeaderCell from '../../components/table/HeaderCell';

const columns = ({ onViewAdmin, onEditAdmin, onDeleteAdmin }) => [
  {
    name: <HeaderCell label={'ID'} />,
    selector: row => row?.id || row?._id,
    width: '200px',
  },
  {
    name: <HeaderCell label={'NAME'} />,
    selector: row => `${row?.first_name || ''} ${row?.surname || ''}`.trim(),
    width: '250px',
  },
  {
    name: <HeaderCell label={'EMAIL'} />,
    selector: row => row?.email_address,
    width: '380px',
  },
  {
    name: <HeaderCell label={'ROLE'} />,
    selector: row => row?.authUser?.role?.toUpperCase() || '-',
    width: '300px',
  },
  {
    name: <HeaderCell label={'ACTION'} />,
    cell: row => (
      <Flex gap={3} align="center">
        <Eye
          width={20}
          height={20}
          cursor={'pointer'}
          onClick={() => onViewAdmin(row)}
        />
        <EditIcon
          width={20}
          height={20}
          cursor={'pointer'}
          onClick={() => onEditAdmin(row)}
        />
        <DeleteIcon
          width={20}
          height={20}
          cursor={'pointer'}
          onClick={() => onDeleteAdmin(row)}
        />
      </Flex>
    ),
    width: '250px',
  },
];

export { columns };
